import { Injectable, Injector, OnInit } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";
import { catchError, finalize, map, Observable, throwError } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ApiService } from "../../../../../shared/services/api-service";

@Injectable({
  providedIn: 'root'
})

export class NotificationService  {

  constructor(private _api: ApiService) {

  }




  async getNotifications(): Promise<any> {
    return await this._api.getMethodsWithoutTokenAndParams('/api/Notification/GetNotifications').then((res) => {
      return res;
    });
  }

  async getNotificationsCount(): Promise<any> {
    return await this._api.getMethodsWithoutTokenAndParams('/api/Notification/GetNotificationsCount').then((res) => {
      return res;
    });
  }


}
